// this should be not hardcoded and somewhere else???
export const excludedLocations: string[] = [
  'American Samoa',
  'Commonwealth Of The Northern Mariana Islands',
  'Guam',
  'United States Virgin Islands',
];
